import moment from 'moment'
import MediaEntity, { IMediaProps } from './Media'
import { toMediaProps } from '@/gateways/Upstream/translator/media'

export interface IRecruitmentProps {
  id?: string
  title: any
  description: any
  properties: any
  media: any
  openedAt: string | null
  closedAt: string | null
  createdAt: string | null
  updatedAt: string | null
}

export default class RecruitmentEntity {
  private _props: IRecruitmentProps

  constructor(props?: IRecruitmentProps | null) {
    this._props = EmptyRecruitmentPropsFactory(props)
  }

  get props(): IRecruitmentProps {
    return this._props
  }

  get clone(): IRecruitmentProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get title(): string {
    return this._props.title?.ja || ''
  }

  get description(): string {
    return this._props.description?.ja || ''
  }

  get properties(): any {
    return this._props.properties
  }

  get media(): IMediaProps[] {
    const media = this._props.media?.length > 0 ? this._props.media : this._props.properties?.media
    return media?.length > 0 ? media.map((prop: any) => toMediaProps(prop)) : []
  }

  get thumbnail(): string {
    if (this.media.length > 0) {
      const media = new MediaEntity(this.media[0])
      return media.src || ''
    }
    return this._props.properties?.thumbnail || ''
  }

  get prefecture(): string {
    return this._props.properties?.prefecture || ''
  }

  get working(): string {
    return this._props.properties?.working || ''
  }

  get content(): string {
    return this._props.properties?.content || ''
  }

  get facility(): string {
    return this._props.properties?.facility || ''
  }

  get robot(): string {
    return this._props.properties?.robot || ''
  }

  get openedAt(): string | null {
    return this._props.openedAt ? moment(this._props.openedAt).format('YYYY/MM/DD') : null
  }

  get closedAt(): string | null {
    return this._props.closedAt ? moment(this._props.closedAt).format('YYYY/MM/DD') : null
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get arrival(): boolean {
    return moment().isBefore(moment(this._props.openedAt).add(8, 'd'))
  }
}

export const EmptyRecruitmentPropsFactory = (props?: Partial<IRecruitmentProps> | null): IRecruitmentProps => ({
  title: {},
  description: {},
  properties: {},
  media: [],
  openedAt: null,
  closedAt: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
